appConfig.getModule()
    .service('session', ['$rootScope', 'commonService',
        function ($rootScope, commonService) {
            var self = this;
            // creates the cookie for current user and also stores user information in root scope.
            self.create = function (user) {
                self.user = user;
                $rootScope.currentUser = user;
                commonService.localStorage.setKeyValue('currentUser', user);
            };

            self.destroy = function () {
                self.id = undefined;
                self.user = undefined;
                $rootScope.currentUser = undefined;
                commonService.localStorage.setKeyValue('currentUser', '');
            };

            self.getSession = function () {
                return commonService.localStorage.getKeyValue('currentUser') || undefined;
            }

        }
    ])

    // .factory("turf", function() {

    // })

    .factory('authService', ['$http', '$q', '$location', 'session', '$rootScope', 'commonService', 'SERVICE_CALL',
        function ($http, $q, $location, session, $rootScope, commonService, SERVICE_CALL) {

            var authService = {};

            // login
            authService.login = function (credentials) {

                var deferred = $q.defer();

                $http(commonService.createHttpRequestObject(null, credentials, 'users/login'))
                    .success(function (res) {
                        if (res.success) {
                            session.create(res.data.user);
                            deferred.resolve(res);
                        } else {
                            deferred.reject(res.err);
                        }
                    });

                return deferred.promise;

            }

            // Regsietr
            authService.register = function (registration) {
                registration.url=$location.absUrl();  //added to generate link in email
                var deferred = $q.defer();
                $http(commonService.createHttpRequestObject(null, registration, 'users/register'))
                    .success(function (res) {
                        if (res.success) {
                            session.create(res.data.user);
                            deferred.resolve(res);
                        } else {
                            deferred.reject(res.err);
                        }
                    });

                return deferred.promise;

            }

            // logout for user.
            authService.logout = function () {

                var deferred = $q.defer();

                $http(commonService.createHttpRequestObject(null, null, 'users/logout'))
                    .then(function (res) {
                        authService.destroySession();
                        deferred.resolve(res);
                    });

                return deferred.promise;

            }

            // destroy the current session and local storage.
            authService.destroySession = function () {
                session.destroy();
                commonService.localStorage.clearAll();
            }

            // check if user is logged in
            authService.isAuthenticated = function () {

                var deferred = $q.defer();

                var user = session.getSession();

                // if user id found in cookie than request is authetnicated else check via service call.
                //if (angular.isUndefined(user) || angular.isUndefined(user.userName)) {
                $http(commonService.createHttpRequestObject(SERVICE_CALL.system.getSessionDetails))
                    .success(function (res) { 
                        if (res.success) {
                            session.create(res.data.user);
                            deferred.resolve(true);
                        } else {
                            authService.destroySession();
                            deferred.resolve(false);
                        }
                    });
                /*} else {
                    $rootScope.currentUser = user;
                    deferred.resolve(true);
                }*/

                return deferred.promise;

            };

            authService.isAuthorized = function (moduleName, action) {

                var authorized = false;

                var permissions = authService.getPermissions();

                if (permissions) {
                    if (permissions[moduleName]) {
                        authorized = permissions[moduleName][action] || false;
                    }
                }

                return authorized;

            };

            authService.isAuthorized2 = function (moduleName) {
                var authorized = false;
                if($rootScope.currentUser && $rootScope.currentUser.role == 'Admin') {
                    // all allowed
                    authorized = true;
                } else if($rootScope.currentUser && $rootScope.currentUser.role == 'Public') {
                    // limited access
                    var publicAccessArray = ['dfaBYD.dashboard.gallery', 'dfaBYD.dashboard.preview'];
                    if(publicAccessArray.indexOf(moduleName) !== -1) {
                        authorized = true;
                    }
                }             
                return authorized;
            };

            authService.getPermissions = function () {

                var user = session.getSession();

                if (user && user.permissions) {
                    return user.permissions;
                }

                return '';

            }

            authService.getDefaultWorkspace = function () {

                var deferred = $q.defer();

                $http(commonService.createHttpRequestObject(SERVICE_CALL.system.getDefaultWorkspace))
                    .success(function (res) {
                        if (res.success) {
                            deferred.resolve(res.data);
                        } else {
                            deferred.resolve(res.err);
                        }
                    });

                return deferred.promise;
            }

            return authService;

        }
    ])
    .factory('commonService', ['$http', '$q', '$rootScope', '$httpParamSerializerJQLike', 'SERVICE_CALL', 'localStorageService',
        function ($http, $q, $rootScope, $httpParamSerializerJQLike, SERVICE_CALL, localStorageService) {

            var commonService = {};

            commonService.createServiceCallUrl = function (serviceCall) {
                return appConfig.serviceCallUrl + serviceCall;
            }

            //creates HTTP request Object as per params Passed.
            commonService.createHttpRequestObject = function (serviceCall, data, url, method, headers) {

                var req = {};

                req['method'] = method || 'POST';

                if (serviceCall) {
                    req['url'] = commonService.createServiceCallUrl(serviceCall);
                } else if (url) {
                    req['url'] = url;
                }

                if (data && req['method'] != 'GET') {

                    var token = commonService.getToken();

                    if (token != '') {
                        data['_token'] = token;
                    }

                    req['data'] = $httpParamSerializerJQLike(data);
                }

                if(data && req['method'] == 'GET') {
                    req['params'] = data;
                }

                req['headers'] = angular.merge({
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Expires': 0
                }, headers);

                if ($rootScope.ignoreLoadingBar) {
                    req['ignoreLoadingBar'] = true;
                }

                return req;
            }

            // sets a default value for a property if property does not exist in an object
            commonService.ensureDefault = function (obj, prop, value) {
                if (!obj.hasOwnProperty(prop))
                    obj[prop] = value;
            }

            /** User Preferences **/
            commonService.getCurrentUserPref = function () {

                var userPref;

                var userPref = commonService.localStorage.getKeyValue('userPref', true)[$rootScope.currentUser.username];

                return userPref;

            }

            // generates random number from 1 - 100
            commonService.generateRandomNumber = function generateRandomNumber() {
                return Math.floor((Math.random() * 100) + 1);
            }

            // generates random numbers from min (inclusive) and max (inclusive)
            commonService.generateRandomNumberInRange = function generateRandomNumberInRange(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }

            /*** Local Storage ***/
            commonService.localStorage = {};

            commonService.localStorage.checkSupport = function () {
                return localStorageService.isSupported;
            }

            commonService.localStorage.getUserPreference = function (module, moduleType, key) {

                var userPreference = undefined;

                var dbPreference = commonService.localStorage.getKeyValue(module);

                if (dbPreference != null) {
                    if (dbPreference[moduleType]) {
                        userPreference = dbPreference[moduleType][key];
                    }
                }

                return userPreference;
            }

            commonService.localStorage.setUserPreference = function (module, moduleType, key, value) {

                var dbPreference = commonService.localStorage.getKeyValue(module, true);

                if (dbPreference[moduleType]) {
                    dbPreference[moduleType][key] = value;
                } else {
                    dbPreference[moduleType] = {};
                    dbPreference[moduleType][key] = value;
                }

                return commonService.localStorage.setKeyValue(module, dbPreference);

            }

            commonService.localStorage.clearAll = function () {
                return localStorageService.clearAll(/^((?!(translation|userPref|logoutFrom|_SHOW_LOGIN_DETAILS_)).)*$/);
            }

            commonService.localStorage.setKeyValue = function (key, value) {
                return localStorageService.set(key, value);
            }

            commonService.localStorage.getKeyValue = function (key, createIfDoesntExist) {

                var value = localStorageService.get(key);

                if (value == null && createIfDoesntExist) {
                    value = {};
                    commonService.localStorage.setKeyValue(key, value);
                }

                return value;
            }

            /** ENCRYPTION **/
            commonService.encrypt = function (value) {
                var encryptedVal = '';

                var encrypt = new JSEncrypt();
                
                var PUK = "-----BEGIN PUBLIC KEY-----\
                MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC40p0Xe3HZXrBVuPUkQQkIdZsa\
                dgw/nhY7CXWUxozuRlgUbm3E5mTnmJyZJ1NiwJnOeRTRFeZxUm4SVPAE1I/Xp8cv\
                5jX43QM+EPB9fJS2KoUcI5sHlIdYdCFxXVtV4jGRgBzoJjGuU8XazMqo8xxI2Bbq\
                5L6/RXRtRncj8ztx7wIDAQAB\
                -----END PUBLIC KEY-----";

                encrypt.setKey(PUK);

                encryptedVal = encrypt.encrypt(value);

                return encryptedVal;
            }

            commonService.getToken = function () {

                var token = decodeURIComponent(getCookie('XSRF-TOKEN'));

                if (token && token != '') {
                    return commonService.encrypt(token);
                }

                return '';
            }

            function getCookie(cname) {
                var name = cname + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1);
                    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
                }
                return "";
            }

            commonService.getVersionInfoFromFile = function () { 
                var deferred = $q.defer();
                var fileurl = SERVICE_CALL.dfaVersion.versionApi;
                $http.get(fileurl).success(function (res) {
                    if (res) {
                        deferred.resolve(res);
                    }
                });        
                return deferred.promise;        
            }

            return commonService;

        }
    ])
    .factory('authInterceptor', ['$rootScope', '$q', 'AUTH_EVENTS',
        function ($rootScope, $q, AUTH_EVENTS) {
            return {
                responseError: function (response) {
                    switch (response.status) {
                        case 401:
                            $rootScope.$emit(AUTH_EVENTS.notAuthenticated);
                            return $q.reject(response);
                        case 403:
                            $rootScope.$emit(AUTH_EVENTS.notAuthorized);
                            return $q.reject(response);
                        case 500:
                            alert('Something went wrong: Internal Server Error');
                            return $q.reject(response);
                        default:
                            return $q.reject(response);
                    }
                }
            };
        }])
    .factory('errorService', ['modalService', '$rootScope',
        function (modalService, $rootScope) {

            var errorService = {};

            errorService.resolve = function (errObj) {

                var errorMessage = 'An error occurred during the process.';

                if (errObj != undefined) {

                    if (errObj.code != undefined && errObj.code != '') {
                        errorMessage = $rootScope.getTranslatedKey(errObj.code);
                    } else if (angular.isDefined(errObj.msg)) {
                        errorMessage = errObj.msg;
                    }

                }

                return errorMessage;

            }

            errorService.show = function (errObj) {
                modalService.show({}, {
                    actionButtonText: 'OK',
                    headerText: 'Error',
                    bodyText: errorService.resolve(errObj),
                    showCloseButton: false
                })
            }

            return errorService;

        }
    ])
    .factory('onSuccessDialogService', ['modalService',
        function (modalService) {

            var onSuccessDialogService = {};

            onSuccessDialogService.show = function (msg, callBack) {
                modalService.show({
                    backdrop: false
                }, {
                        actionButtonText: 'OK',
                        headerText: 'Success',
                        bodyText: msg,
                        showCloseButton: false
                    }).then(function (result) {
                        if (callBack != undefined) {
                            callBack();
                        }
                    })
            }

            return onSuccessDialogService;

        }
    ])
    .factory('agGridService', ['$rootScope', '$location', '$q', 'AUTH_EVENTS', '$filter', 
        function ($rootScope, $location, $q, AUTH_EVENTS, $filter) {
            var agGridService = {};
            var str = "gridRow_";

            agGridService.agGridSerivice = function (pk, columnDefs, property, sk) {
                if ( angular.isDefined(property) && (property.serverRequest)) {
                    return agGridService.agGridServerSide(pk, columnDefs, property);
                }
                else {
                    return agGridService.agGridClientSide(pk, columnDefs, property, sk);
                }
            };

            agGridService.agGridClientSide = function (pk, columnDefns, property, sk) {
                columnDefs = [];
                angular.forEach(columnDefns, function(col, key){
                    if(col.headerName === '') {
                        if(col.checkboxSelection) {
                            col.headerCheckboxSelection = true;
                            col.headerCheckboxSelectionFilteredOnly = true;
                        }
                        col.suppressFilter = true;
                    }
                    if(col.headerName === 'Actions') {
                        col.suppressFilter = true;
                    }
                    columnDefs.push(col);
                });
                agGridService.clientside = {
                    headerHeight: 32,
                    rowHeight: 35,
                    minColWidth: 50,
                    enableSorting: true,
                    enableFilter: true,
                    enableColResize: true,
                    toolPanelSuppressPivotMode: true,
                    angularCompileRows: true,
                    toolPanelSuppressSideButtons: (columnDefs.length > 3) ? ( ( angular.isDefined(property) && angular.isDefined(property.toolPanelBtn) && (!property.toolPanelBtn)) ? true : false ) : true,
                    suppressRowClickSelection: true,
                    rowMultiSelectWithClick: true,
                    floatingFilter: ((property === undefined) || (property.floatingFilters === undefined) || (property.floatingFilters !== false)) ? true : false,
                    //pagination: true,
                    //suppressColumnsToolPanel: true,
                    //sideBar: null,
                    //toolPanel: null,
                    groupDefaultExpanded: 1,
                    //suppressColumnsToolPanel: true,
    
                    onGridSizeChanged: function (params) {
                        if((columnDefs != undefined) && (columnDefs.length <= 2)) {
                            var keepGoing = true;
                            angular.forEach(columnDefs, function (col) {
                                if( keepGoing && (col.width === undefined)) {
                                    onGridSizeChanged(params);
                                    keepGoing = false;
                                }
                            });
                        }
                        else {
                            return true;
                        }
                    },
                    //debug: true,
                    rowDeselection: false,
                    rowSelection: 'multiple',
                    onFilterChanged: function (value) {
                        $rootScope.totalCount[pk+'_rowCounter'] = 0;
                        $rootScope.totalCount[pk + '_count'] = (value.api.getDisplayedRowCount()) ? $filter('number')(value.api.getDisplayedRowCount()) : 0;
                        $rootScope.totalCount[pk+'_lastRow'] = value.api.rowRenderer.lastRenderedRow + 1;
                        setGridPreferences(this, pk, property);
                    },
                    onFilterModified: function(value) {
                        $rootScope.totalCount[pk + '_rowCounter'] = 0;
                        $rootScope.totalCount[pk + '_count'] = (value.api.getDisplayedRowCount()) ? $filter('number')(value.api.getDisplayedRowCount()) : 0;
                    },
                    onSortChanged: function() {
                        //setGridPreferences(this, pk, property);
                    },
                    onColumnPinned: function (params) {
                        //setGridPreferences(this, pk, property);
                    },
                    onColumnMoved: function (params) {
                        //setGridPreferences(this, pk, property);
                    },
                    onColumnVisible: function (params) {
                        setGridPreferences(this, pk, property);
                    },
                    columnDefs: columnDefs,
                    rowData: [],
                    onGridReady: function (params) { 
                        getGridPreferences(this, pk, property);
                        var requestData = {
                            'dashId': $rootScope.dashboardId,
                        };
                        switch (pk) {
                            case 'areaNid':
                                $rootScope.$broadcast('areaData', {
                                    requestData: requestData,
                                    params: params
                                });
                                break;       
                            default:
                        }
                    }    
                };
    
                var modulePage = ( angular.isDefined(property) && (property.module)) ? property.module : '';
                if((pk !== 'data_nid') && (modulePage !== 'IC_IUS')){
                    agGridService.clientside['getRowNodeId'] = function (item) {
                        if (sk !== undefined && item[sk] !== undefined) return item[sk];
                        
                        // the id can be any string, as long as it's unique within your dataset
                        return item[pk];
                    }
                }   
    
                return agGridService.clientside;
            };

            agGridService.agGridServerSide = function (pk, columnDefns, property) {
                columnDefs = [];
                angular.forEach(columnDefns, function(col, key){
                    if((col.headerName === '') || (col.headerName === 'Actions')) {
                        col.suppressFilter = true;
                    }
                    columnDefs.push(col);
                });
    
                agGridService.serverside = {
                    angularCompileRows: true,
                    headerHeight: 32,
                    rowHeight: 45,
                    sideBar: (columnDefs != undefined && columnDefs.length > 3) ? true : false,
                    toolPanelSuppressSideButtons: (columnDefs != undefined && columnDefs.length > 3) ? false : true,
                    toolPanelSuppressValues: true,
                    toolPanelSuppressRowGroups: true,
                    toolPanelSuppressPivotMode: true,
                    suppressRowClickSelection: true,
                    suppressContextMenu: true,
                    enableServerSideSorting: true,
                    enableServerSideFilter: true,
                    enableColResize: true,
                    rowMultiSelectWithClick: true,
                    rowBuffer: 0,
                    getRowNodeId: function (item) {
                        /*var totalCount = $rootScope.totalCount[pk+'_totalCount'];
                        if(!angular.isDefined($rootScope.totalCount[pk+'_rowCounter'])) {
                            $rootScope.totalCount[pk+'_rowCounter'] = 0;
                        }
                        $rootScope.totalCount[pk+'_rowCounter'] += 1;
                        if (totalCount > 7) {
                            if (totalCount == $rootScope.totalCount[pk+'_rowCounter'])
                                return str + 'last';
                            else if (totalCount - 1 == $rootScope.totalCount[pk+'_rowCounter'])
                                return str + 'second_last';
                        }*/
                        // the id can be any string, as long as it's unique within your dataset
                        return item[pk];
                    },
                    floatingFilter: ((property === undefined) || (property.floatingFilters === undefined) || (property.floatingFilters !== false)) ? true : false,
                    //debug: true,
                    rowSelection: 'multiple',
                    rowDeselection: true,
                    isRowSelectable: function (node) {
                        return true;
                    },
                    //onGridSizeChanged: onGridSizeChanged,
                    onGridSizeChanged: function (params) {
                        if((columnDefs != undefined) && (columnDefs.length <= 2)) {
                            var keepGoing = true;
                            angular.forEach(columnDefs, function (col) {
                                if( keepGoing && (col.width === undefined)) {
                                    onGridSizeChanged(params);
                                    keepGoing = false;
                                }
                            });
                        }
                        else {
                            return true;
                        }
                    },
                    onFilterChanged: function() {
                        $rootScope.totalCount[pk+'_rowCounter'] = 0;
                        setGridPreferences(this, pk, property);
                    },
                    onFilterModified: function() {
                        $rootScope.totalCount[pk+'_rowCounter'] = 0;
                    },
                    onSortChanged: function() {
                        setGridPreferences(this, pk, property);
                    },
                    onColumnPinned: function (params) {
                        setGridPreferences(this, pk, property);
                    },
                    onColumnMoved: function (params) {
                        setGridPreferences(this, pk, property);
                    },
                    onColumnVisible: function (params) {
                        setGridPreferences(this, pk, property);
                    },
                    // tell grid we want virtual row model type
                    rowModelType: 'infinite',
                    cacheBlockSize: Number($rootScope.systemConfig.PAGE_LIMIT),
                    // pagination: true,
                    // how big each page in our page cache will be, default is 100
                    paginationPageSize: Number($rootScope.systemConfig.PAGE_LIMIT),
                    // how many extra blank rows to display to the user at the end of the dataset,
                    // which sets the vertical scroll and then allows the grid to request viewing more rows of data.
                    // default is 1, ie show 1 row.
                    cacheOverflowSize: 2,
                    // how many server side requests to send at a time. if user is scrolling lots, then the requests
                    // are throttled down
                    maxConcurrentDatasourceRequests: 2,
                    // how many rows to initially show in the grid. having 1 shows a blank row, so it looks like
                    // the grid is loading from the users perspective (as we have a spinner in the first col)
                    infiniteInitialRowCount: 1,
                    // how many pages to store in cache. default is undefined, which allows an infinite sized cache,
                    // pages are never purged. this should be set for large data to stop your browser from getting
                    // full of data
                    //maxBlocksInCache: 1,
                    //maxRowFound: true,
    
                    columnDefs: (columnDefs != undefined)?columnDefs:[],
                    onGridReady: function (params) {
                        // params.api.closeToolPanel();
                        getGridPreferences(this, pk, property);
    
                        if((property === undefined) || (property.sizeColumnsToFit === undefined) || (property.sizeColumnsToFit !== false)) {
                            setTimeout(function(){
                                params.api.sizeColumnsToFit();
                                //Setting the event for after columns are fit
                                if(pk == 'iuNid'){
                                    $rootScope.$broadcast('afterColumnResize', {});
                                }
                            }, 2500);
                        }
                        
                        var dataSource = {
                            rowCount: null,
                            getRows: function (params) {
                                var pageSize = params.endRow - params.startRow, pageNum = 1 + (params.startRow / pageSize);
    
                                var requestData = {
                                    'dbId': $rootScope.currentDatabase.id,
                                    'pageSize': pageSize,
                                    'pageNum': pageNum,
                                    'filter': params.filterModel,
                                    'sort': params.sortModel
                                };
    
                                switch (pk) {
                                    case 'indicator_nid':
                                        $rootScope.$broadcast('indicatorData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;
                                    case 'unit_nid':
                                        $rootScope.$broadcast('unitData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;
                                    case 'timeperiod_nid':
                                        $rootScope.$broadcast('tpData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;
                                    case 'subgroup_val_nid':
                                        $rootScope.$broadcast('subgroupvalData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;
                                    case 'iusnid':
                                        $rootScope.$broadcast('iusData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;
                                    case 'sNid':
                                    case 'subgroup_nid':
                                        $rootScope.$broadcast('subgroupData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;
                                    case 'dNid':
                                        $rootScope.$broadcast('dimensionData', {
                                            requestData: requestData,
                                            params: params
                                        });
                                        break;    
                                    case 'iuNid':
                                        $rootScope.$broadcast('iuData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;    
                                    case 'etl_id':
                                        $rootScope.$broadcast('etlData', {
                                            requestData: requestData,
                                            params: params,
                                            serverRequest: property.serverRequest
                                        });
                                        break;   
                                    case 'ic_nid': //For Source
                                       $rootScope.$broadcast('sourceData', {
                                    requestData: requestData,
                                    params: params
                                });
                                break; 
                                    default:
                                }
                            } // end of get rows
                        };
    
                        //Storing the data-source in rootscope to be utilized later
                        if(pk == 'iuNid'){
                            $rootScope.dtstSrcIu = dataSource;
                        } else if(pk == 'iusnid') {
                            $rootScope.dtstSrcIus = dataSource;
                        }
    
                        // Merge object2 into object1
                        $.extend( agGridService.serverside, {datasource: dataSource} );
    
                        //Set the data-source now
                        params.api.setDatasource(dataSource);
                    },
                    onBodyScroll: function (params) {
    
                    }
                };
                return agGridService.serverside;
            };
            function setGridPreferences($this, pk, property) {
                var templateName = '';
                var arr = $location.url().split('Template/');
                if(angular.isDefined(arr[1]) && arr[1]) {
                    templateName = arr[1].split('/')[0];
                }
                var arr = $location.url().split('Data/');
                if(angular.isDefined(arr[1]) && arr[1]) {
                    templateName = arr[1].split('/')[0];
                }
                if(pk == 'data_nid')  templateName="Data";
                if(pk == 'data_nid')  templateName="Data";          
                if(pk == 'timeperiod_nid')  templateName="TimePeriod";          
    
                var moduleName = (templateName) ? (templateName + '_' + pk + '_' + $rootScope.currentDatabase.id) : '';
                var gridPersistance = {};
                gridPersistance['moduleKey'] = moduleName;
                gridPersistance[moduleName] = {
                    'pk': pk,
                    'module': templateName,
                    'dbId': $rootScope.currentDatabase.id,
                    'columnState': (pk == 'data_nid') ? '' :$this.columnApi.getColumnState(),
                    'filterState': $this.api.getFilterModel(),
                    'sortState': $this.api.getSortModel()
                };
                if((property !== undefined) && (property.gridPersistance !== undefined) && (property.gridPersistance === false)) {
                    // Ignore in the case of property.gridPersistance: false
                }
                else if(moduleName){
    
                    $http(commonService.createHttpRequestObject(SERVICE_CALL.userManagement.updateUserInfo, gridPersistance, null, 'POST', null, true ))
                        .success(function (res) {
                                if (res.success) {
                                    $rootScope.currentUser.sel_objects = res.data.updatedUserInfo;
                                } else {
                                }
                            }
                        );
                }
    
    
            }
            function getGridPreferences($this, pk, property) {
                var templateName = '';
                var arr = $location.url().split('Template/');
                if(angular.isDefined(arr[1]) && arr[1]) {
                    templateName = arr[1].split('/')[0];
                }
    
                if(pk == 'data_nid')  templateName="Data";
                // if(pk == 'ic_nid')  templateName="Source";
                var arr = $location.url().split('Data/');
                if(angular.isDefined(arr[1]) && arr[1]) {
                    templateName = arr[1].split('/')[0];
                }
                if(pk == 'timeperiod_nid')  templateName="TimePeriod";
                
                var moduleName = (templateName) ? (templateName + '_' + pk + '_' + $rootScope.currentDatabase.id) : '';
    
                var gridPreferences = {};
    
                var columnState = (angular.isDefined(gridPreferences[moduleName]) && angular.isDefined(gridPreferences[moduleName].columnState)) ? gridPreferences[moduleName].columnState : {};
                var filterState = (angular.isDefined(gridPreferences[moduleName]) && angular.isDefined(gridPreferences[moduleName].filterState)) ? gridPreferences[moduleName].filterState : {};
                var sortState = (angular.isDefined(gridPreferences[moduleName]) && angular.isDefined(gridPreferences[moduleName].sortState)) ? gridPreferences[moduleName].sortState : {};
    
                if((property !== undefined) && (property.gridPersistance !== undefined) && (property.gridPersistance === false)) {
    
                }
                else {
                    if (!angular.equals(columnState, {}) && pk != 'data_nid')
                        $this.columnApi.setColumnState(columnState);
                    if (!angular.equals(filterState, {}))
                        $this.api.setFilterModel(filterState);
                    if (!angular.equals(sortState, {}))
                        $this.api.setSortModel(sortState);
                }
            }
            function onGridSizeChanged(params) {
                // fill out any available space to ensure there are no gaps
                params.api.sizeColumnsToFit();
            }
    
            agGridService.loaderRendererFunc = function (params)
            {
                if (params.value !== undefined) {
                    return params.value;
                } else {
                    return '<img src="img/loading.gif">'
                }
            };    
    
            agGridService.changeBoolRendererFunc = function (params)
            {
                if (params.value !== undefined) {
                    if (params.value === true)
                        return '<i class="fa fa-check-square-o" aria-hidden="true"></i>';
                    else if (params.value === false)
                        return '';
                }
            };
    
            agGridService.changeIntToYesNoRendererFunc = function (params)
            {
                if (params.value !== undefined) {
                    if (params.value == 1)
                        return 'Yes';
                    else if (params.value == 0)
                        return 'No';
                }
            };
    
            agGridService.radioBoxCellRenderer = function (params, pk, isDisable, isChecked) {
                var subgroupNid = null;
                if ((params.data != undefined) && (params.data[pk] != undefined)) {
                    subgroupNid = (params.data[pk]) ? params.data[pk] : null;
                }
                var status = (isDisable) ? "disabled" : "enable";
                var checked = (isChecked) ? "checked" : "";
                return '<input type="radio" class="gridradio" ng-click="radioSelection('+subgroupNid+')" id="radio_'+ subgroupNid +'" name="defaultSubgrp" value="' + subgroupNid + '"  '+ checked +'  '+status+'></input>';
            };
    
            agGridService.executeCellRendererFunc = function (params, pk) {
                var pkValue = '';
                if ((params.data != undefined) && (params.data[pk] != undefined)) {
                    pkValue = params.data[pk];
                }
                this.eGui = document.createElement('span');
                var text = '<button class="btn" style="background-color:white;border:1px solid #aaa;height:28px;" ' +
                           'ng-click="executeAction('+pkValue+')" >'+
                           '{{getTranslatedKey("EXECUTE")}}</button>';
    
                this.eGui.innerHTML = text;
                return this.eGui;
            };
    
            agGridService.actionCellRendererFunc = function (params, pk, actionList) {
                if (pk == 'dGid' &&  angular.isDefined(params.data) && params.data.dNid === undefined) { return; }
                var pkValue = '';
                if ((params.data != undefined) && (params.data[pk] != undefined)) {
                    pkValue = params.data[pk];
                }
                var actionBtn = '';
                angular.forEach(actionList, function (action) {
                    if (action == "VIEW") {
                        actionBtn += '<li role="presentation">' +
                            '<a role="menuitem" tabindex="-1"  ng-click="viewAction(\''+pkValue+'\')"><i class="fa fa-eye"></i>' + $rootScope.getTranslatedKey("VIEW") + '</a>' +
                            '</li>';
                    }
                    if (action == "EDIT") {
                        actionBtn += '<li role="presentation">' +
                            '<a role="menuitem" tabindex="-1"  ng-click="editAction(\''+pkValue+'\')"><i class="fa fa-pencil"></i>' + $rootScope.getTranslatedKey("EDIT") + '</a>' +
                            '</li>';
                    }
                    if (action == "DELETE") {
                        actionBtn += '<li role="presentation">' +
                            '<a role="menuitem" tabindex="-1" ng-click="deleteAction(\''+pkValue+'\')"><i class="fa fa-trash"></i>' + $rootScope.getTranslatedKey("DELETE") + '</a>' +
                            '</li>';
                    }
                });
    
                this.eGui = document.createElement('span');
                var text = '<div class="customDropdown">' +
                    '<div class="dropdown" dropdown> ' +
                    '<button class="btn btn-dropdown action-toggle" dropdown-toggle>' +
                    $rootScope.getTranslatedKey("ACTION") +
                    '<span class="caret-down"></span>' +
                    '</button>' +
                    '<ul class="dropdown-menu action-dropdown" role="menu" aria-labelledby="action-menu">' +
                    '<div class="dropdown-arrow"><i class="fa fa-caret-up"></i></div>' +
                    actionBtn +
                    '</ul>' +
                    '</div></div>';
    
                this.eGui.innerHTML = text;
                return this.eGui;
            };    
    
            agGridService.fillGridData = function (pk, apiObj, success, params, serverRequest)
            {
                //$rootScope.totalCount[pk + '_count'] = $filter('number')(success.count);//new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(success.counts);
                //$rootScope.totalCount[pk + '_totalCount'] = $filter('number')(success.totalCount);//new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(success.counts);
                // $rootScope.totalCount[pk+'_lastRow'] = (params.endRow > success.counts) ? success.counts : params.endRow;
                if(serverRequest) {
                    rowsToAdd = [];
                    $.each(success.data, function (index, value) {
                        rowsToAdd.push(value);
                    });
                    fullWidthRowAdded = success.data.count;
                    var lastRow = params.endRow + fullWidthRowAdded;
                    lastRow = (params.endRow >= success.count) ? success.count : -1;
                    params.successCallback(rowsToAdd, lastRow);
                }
                else { 
                    apiObj.api.setRowData(success.data);
                    apiObj.api.sizeColumnsToFit();
                }
            };
    
            agGridService.refreshGridData = function (apiObj, serverRequest, pk)
            {
                if (serverRequest)
                    apiObj.api.purgeInfiniteCache();
                else {
                    var decrease=apiObj.api.getSelectedRows().length;
                    $rootScope.totalCount[pk+'_totalCount']-=decrease;
                    $rootScope.totalCount[pk+'_count']-=decrease;
                    angular.forEach(apiObj.api.getSelectedNodes(), function (node) {
                        if (node.childrenAfterGroup == undefined) node = [node.data];
                        else node = getRowsToRemove(node);
                        apiObj.api.updateRowData({ remove: node });
                    });
                }
                    
            };    
    
            agGridService.numericEditorFunc = function (NumericCellEditor) {    
                // gets called once before the renderer is used
                NumericCellEditor.prototype.init = function (params) {
                    // create the cell
                    this.eInput = document.createElement('input');
                    //this.eInput.classList.add("ag-cell-focus");
                    this.eInput.setAttribute("style", "border: 1px solid #0091EA !important;");
    
                    if (isCharNumeric(params.charPress)) {
                        this.eInput.value = params.charPress;
                    } else {
                        if (params.value !== undefined && params.value !== null) {
                            this.eInput.value = params.value;
                        }
                    }
    
                    var that = this;
                    this.eInput.addEventListener('keypress', function (event) {
                        if (!isKeyPressedNumeric(event)) {
                            that.eInput.focus();
                            if (event.preventDefault) event.preventDefault();
                        } else if (that.isKeyPressedNavigation(event)){
                            event.stopPropagation();
                        }
                    });
    
                    // only start edit if key pressed is a number, not a letter
                    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
                    this.cancelBeforeStart = charPressIsNotANumber;
                };
    
                NumericCellEditor.prototype.isKeyPressedNavigation = function (event){
                    return event.keyCode===39
                        || event.keyCode===37;
                };
    
    
                // gets called once when grid ready to insert the element
                NumericCellEditor.prototype.getGui = function () {
                    return this.eInput;
                };
    
                // focus and select can be done after the gui is attached
                NumericCellEditor.prototype.afterGuiAttached = function () {
                    this.eInput.focus();
                };
    
                // returns the new value after editing
                NumericCellEditor.prototype.isCancelBeforeStart = function () {
                    return this.cancelBeforeStart;
                };
    
                // example - will reject the number if it contains the value 007
                // - not very practical, but demonstrates the method.
                NumericCellEditor.prototype.isCancelAfterEnd = function () {
                    var value = this.getValue();
                    return value.indexOf('007') >= 0;
                };
    
                // returns the new value after editing
                NumericCellEditor.prototype.getValue = function () {
                    return this.eInput.value;
                };
    
                // any cleanup we need to be done here
                NumericCellEditor.prototype.destroy = function () {
                    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
                };
    
                // if true, then this editor will appear in a popup
                NumericCellEditor.prototype.isPopup = function () {
                    // and we could leave this method out also, false is the default
                    return false;
                };
    
                Number.prototype.isFloat = function () {
                    return (this % 1 != 0);
                }
    
                function isCharNumeric(charStr) {
                    if (parseFloat(charStr).isFloat()) return true;
                    return /(\d+(\.\d+)?)/.test(charStr);
                }
    
                function isKeyPressedNumeric(event) {
                    var charCode = getCharCodeFromEvent(event);
                    var charStr = String.fromCharCode(charCode);
                    return isCharNumeric(charStr);
                }
    
                function getCharCodeFromEvent(event) {
                    event = event || window.event;
                    return (typeof event.which == "undefined") ? event.keyCode : event.which;
                }
    
            };    
            function getRowsToRemove(node) {
                var res = [];
                for (var i = 0; i < node.childrenAfterGroup.length; i++) {
                    if(node.id !== undefined) {
                        res = res.concat(getRowsToRemove(node.childrenAfterGroup[i]));
                    }
                }
                // ignore nodes that have no data, i.e. 'filler groups'
                return node.data ? res.concat([node.data]) : res;
            }
    
            return agGridService;
    }])
    .factory('onConfirmDialogService', ['modalService',
        function (modalService) {

            var onConfirmDialogService = {};

            onConfirmDialogService.show = function (msg, callBack) {
                modalService.show({
                    backdrop: false
                }, {
                        actionButtonText: 'OK',
                        headerText: 'Confirmation',
                        bodyText: msg,
                        showCloseButton: true,
                        closeButtonText: 'Cancel'
                    }).then(function (result) {
                        if (callBack != undefined) {
                            callBack();
                        }
                    })
            }

            return onConfirmDialogService;

        }
    ])
    .service('modalService', ['$uibModal',
        function ($uibModal) {

            var modalOptions = {
                closeButtonText: 'Close',
                actionButtonText: 'OK',
                headerText: 'Confirmation',
                bodyText: 'Are you sure you want to perform this action?',
                showCloseButton: true
            };

            var modalDefaults = {
                backdrop: true,
                keyboard: true,
                templateUrl: 'js/app/components/core/views/modal.html'
            };

            this.show = function (customModalDefaults, customModalOptions) {
                //Create temp objects to work with since we're in a singleton service
                var tempModalDefaults = {};
                var tempModalOptions = {};

                //Map angular-ui modal custom defaults to modal defaults defined in service
                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

                //Map modal.html $scope custom properties to defaults defined in service
                angular.extend(tempModalOptions, modalOptions, customModalOptions);

                if (!tempModalDefaults.controller) {
                    tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.modalOptions = tempModalOptions;
                        $scope.confirm = function (result) {
                            $uibModalInstance.close(result);
                        };
                        $scope.close = function (result) {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }]
                }

                return $uibModal.open(tempModalDefaults).result;
            };

        }
    ])
    .service('modalService', ['$uibModal',
        function ($uibModal) {

            var modalOptions = {
                closeButtonText: 'Close',
                actionButtonText: 'OK',
                headerText: 'Confirmation',
                bodyText: 'Are you sure you want to perform this action?',
                showCloseButton: true
            };

            var modalDefaults = {
                backdrop: true,
                keyboard: true,
                templateUrl: 'js/app/components/core/views/modal.html'
            };

            this.show = function (customModalDefaults, customModalOptions) {
                //Create temp objects to work with since we're in a singleton service
                var tempModalDefaults = {};
                var tempModalOptions = {};

                //Map angular-ui modal custom defaults to modal defaults defined in service
                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

                //Map modal.html $scope custom properties to defaults defined in service
                angular.extend(tempModalOptions, modalOptions, customModalOptions);

                if (!tempModalDefaults.controller) {
                    tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.modalOptions = tempModalOptions;
                        $scope.confirm = function (result) {
                            $uibModalInstance.close(result);
                        };
                        $scope.close = function (result) {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }]
                }

                return $uibModal.open(tempModalDefaults).result;
            };

        }
    ])
